/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { displayActionMessage } from 'helpers/utils';
import React, { useRef } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { withRouter } from 'react-router-dom';
import { useModal } from 'hooks';
import { useTranslation } from 'react-i18next';
import firebase from 'firebase/firebase';
import EditPlanModal from '../plans/EditPlanModal';

const PlanItem = ({ id, plan }) => {
  const { t } = useTranslation();
  const adRef = useRef(null);

  const modal = useModal();

  const onEditPlan = async (form) => {
    await firebase
      .editPlan(id, form)
      .catch(() => displayActionMessage('errorMessage1', 'error'));
    modal.onCloseModal();
  };

  const onConfirmDelete = async () => {
    await firebase
      .removeAd(id)
      .catch(() => displayActionMessage('errorMessage1', 'error'));
    adRef.current.classList.remove('item-active');
  };

  const onCancelDelete = () => {
    adRef.current.classList.remove('item-active');
  };

  return (
    <SkeletonTheme color="#e1e1e1" highlightColor="#f2f2f2">
      <div className={`item item-image ${!id && 'item-loading'}`} ref={adRef}>
        <div className="grid-admin grid-count-6">
          <div className="grid-admin grid-col" style={{ padding: '2rem' }}>
            {plan.name || <Skeleton width={50} />}
          </div>
          <div className="grid-admin grid-col-onlydesktop">
            <span className="text-overflow-ellipsis-admin">
              {plan.months || <Skeleton width={50} />}
            </span>
          </div>
          <div className="grid-admin grid-col-onlydesktop">
            <span className="text-overflow-ellipsis-admin">
              {plan.limitProducts || <Skeleton width={50} />}
            </span>
          </div>
          <div className="grid-admin grid-col-onlydesktop">
            <span className="text-overflow-ellipsis-admin">
              {plan.limitPhotos || <Skeleton width={50} />}
            </span>
          </div>
          <div className="grid-admin grid-col-onlydesktop">
            <span className="text-overflow-ellipsis-admin">
              {`${plan.priceEur} € / ${plan.priceChf} CHF` || (
                <Skeleton width={50} />
              )}
            </span>
          </div>
        </div>
        <div className="item-action">
          <button
            className="button button-small"
            onClick={() => modal.onOpenModal()}
            type="button"
          >
            <FontAwesomeIcon icon={faEdit} />
          </button>
          <div className="item-action-confirm">
            <h5>{t('productDeleteConfirm')}</h5>
            <button
              className="button button-small button-border"
              onClick={onCancelDelete}
              type="button"
            >
              {t('noMessage')}
            </button>
            &nbsp;
            <button
              className="button button-small button-danger"
              onClick={onConfirmDelete}
              type="button"
            >
              {t('yesMessage')}
            </button>
            <EditPlanModal onEditPlan={onEditPlan} plan={plan} modal={modal} />
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default withRouter(PlanItem);
